import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
} from "antd";
import axios from "axios";
import { collection, getDocs, query, where } from "firebase/firestore";
import PageHeading from "../../../components/common/PageHeading";

import FormAction from "../../../components/common/FormAction";
import Footer from "../../../components/common/Footer";
import { auth, db } from "../../../firebase";
import "./NewUser.css";
import { useAuthState } from "react-firebase-hooks/auth";
import { toast } from "react-hot-toast";

function NewUser() {
  const navigate = useNavigate();
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);
  const [propertyPermissions, setPropertyPermissions] = useState("1");
  const [isWait, setIsWait] = useState(false);
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  console.log("hello:");
  console.log(companyName);
  const onFinish = async (values) => {
    setIsWait(true);
    const usersRef = collection(db, "allUsers");
    try {
      const querySnapshot = await getDocs(
        query(usersRef, where("email", "==", values.email))
      );

      if (querySnapshot.size > 0) {
        toast.error("Email already taken.");
        setErrorMessage(true);
      } else {
        const userData = {
          email: values.email,
          firstName: values.firstName,
          lastName: values.lastName,
          role: values.role,
          companyName: companyName,
          propertyPermission: values.propertyPermission,
          viewAccess: values.viewAccess,
        };

        try {
          const response = await axios.post(
            "https://us-central1-sayeagle-77c75.cloudfunctions.net/api/users",
            userData
          );
          console.log(response.data); // User created successfully
          toast.success("user created successfully");
          navigate("/generalsettings/manage-users");
        } catch (error) {
          console.error("Error creating user:", error);
          const errorMessage = error.message;
          toast.error(errorMessage);
          setIsWait(false);
        }
      }
    } catch (error) {
      const errorMessage = error.message;
      setIsWait(false);

      toast.error(errorMessage);
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.error(
      "All fields are required. Please fill in all the required information."
    );
    setIsWait(false);
  };

  const checkboxOptions = [
    "Chris Loney",
    "David Spear",
    "Dewitt",
    "Edgar Cunningham",
    "Esteban Lezcano",
    "henry Kusuma",
    "Jevon Gill",
    "LM LLC",
    "Matagorda",
    "maxev",
    "Midwest City Partners",
    "MTM renewals",
    "Not prairie",
    "NW 17th 4 plexes",
    "Orion Properties",
    "prairie",
    "Rhett Tullis",
    "Rhetttullis",
    "Select Solutions",
    "Sittenauer",
    "Skram Properties",
    "Southern Nazarene",
    "Striped Eagle",
    "Sunflower",
    "Sweethome properties",
    "Teresa Price",
    "test group",
    "Tim Helms",
    "value added",
    "wopp",
  ];

  const handlePropertyPermission = (e) => {
    setPropertyPermissions(e.target.value);
  };

  const handleChangeEmail = () => {
    setErrorMessage(false);
  };
  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="Add a New User to Your Account" />
          <Form
            className="user-profile"
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 11 }}
            colon={false}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={{ viewAccess: "1" }}
          >
            <Row>
              <Col className="new-user" span={24}>
                <Card title="Profile">
                  <Form.Item
                    label="Email Address"
                    name="email"
                    validateStatus={errorMessage && "error"}
                    help={
                      errorMessage &&
                      "Email already taken. Please use a different email address."
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please input user email address!",
                      },
                    ]}
                  >
                    <Input onChange={handleChangeEmail} />
                  </Form.Item>
                  <Form.Item
                    label="First Name"
                    name="firstName"
                    rules={[
                      {
                        required: true,
                        message: "Please input user first name!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Last Name"
                    name="lastName"
                    rules={[
                      {
                        required: true,
                        message: "Please input user last name!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Role"
                    name="role"
                    rules={[
                      {
                        required: true,
                        message: "Please select user role!",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      placeholder="Select a role"
                      style={{
                        width: "100%",
                      }}
                      options={[
                        {
                          value: "President",
                          label: "President",
                        },
                        {
                          value: "Accountant",
                          label: "Accountant",
                        },
                        {
                          value: "Property Manager",
                          label: "Property Manager",
                        },
                        {
                          value: "On-Site Manager",
                          label: "On-Site Manager",
                        },
                        {
                          value: "Leasing Agent",
                          label: "Leasing Agent",
                        },
                        {
                          value: "Accounts Payable",
                          label: "Accounts Payable",
                        },
                        {
                          value: "Accounts Receivable",
                          label: "Accounts Receivable",
                        },
                        {
                          value: "View Only",
                          label: "View Only",
                        },
                        {
                          value: "Maintenance Coordinator",
                          label: "Maintenance Coordinator",
                        },
                        {
                          value: "Maintenance Tech",
                          label: "Maintenance Tech",
                        },
                        {
                          value: "Regional Manager",
                          label: "Regional Manager",
                        },
                        {
                          value: "Assistant Property Manager",
                          label: "Assistant Property Manager",
                        },
                        {
                          value: "Assistant leasing agent",
                          label: "Assistant leasing agent",
                        },
                      ]}
                    />
                  </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col className="property-groups" span={24}>
                <Card title="Property Groups and Portfolios">
                  <Form.Item name="viewAccess">
                    <Radio.Group onChange={handlePropertyPermission}>
                      <Space direction="vertical">
                        <Radio value="1">
                          View all Property Groups & Portfolios
                        </Radio>
                        <Radio value="2">
                          View these Property Groups & Portfolios only:
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item
                    name="propertyPermission"
                    className="propertyPermission"
                  >
                    <Checkbox.Group
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: "5%",
                      }}
                      options={checkboxOptions}
                      disabled={propertyPermissions === "2" ? false : true}
                    />
                  </Form.Item>

                  <Button
                    type="link"
                    onClick={() => navigate("/generalsettings/property-groups")}
                  >
                    Add New Property Group
                  </Button>
                </Card>
              </Col>
            </Row>
            <FormAction
              submit="submit"
              btnText={isWait ? "wait..." : "submit"}
              disable={isWait}
            />
          </Form>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar"></div>
    </>
  );
}

export default NewUser;
